// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';
import 'amfe-flexible'

Vue.config.productionTip = false

Vue.prototype.$api = require('./assets/js/api/common.js').default;
Vue.prototype.$util = require('./assets/js/util/util.js').default;
Vue.prototype.$config = require('./assets/js/config.js').default;
Vue.prototype.$lang = require('./assets/js/lang.js').default;
Vue.prototype.$layer = layer(Vue, {
  msgtime: 2,//目前只有一项，即msg方法的默认消失时间，单位：秒
});

import NewHeader from './components/NewHeader.vue'
Vue.component('NewHeader',NewHeader)

import NewFooter from './components/NewFooter.vue'
Vue.component('NewFooter',NewFooter)

import NewUserLeft from './components/NewUserLeft.vue'
Vue.component('NewUserLeft',NewUserLeft)

import EmptyBox from './components/EmptyBox.vue'
Vue.component('EmptyBox',EmptyBox)

import SearchBox from './components/SearchBox.vue'
Vue.component('SearchBox',SearchBox)

import Paginate from './components/Paginate.vue'
Vue.component('Paginate',Paginate)

import RecommendFactory from './components/RecommendFactory.vue'
Vue.component('RecommendFactory',RecommendFactory)

import Factory from './components/Factory.vue'
Vue.component('Factory',Factory)

import ProductDetail from './components/ProductDetail.vue'
Vue.component('ProductDetail',ProductDetail)

import RequestBook from './components/RequestBook.vue'
Vue.component('RequestBook',RequestBook)

import store from './store/store'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js